export default __webpack_public_path__ + "static/media/get_started_bg.557f8254.png";